import { Close } from '@zappyrent/hundop';

import {
  StyledCloseButton,
  StyledContent,
  StyledTitle,
  StyledWrapper,
} from './Drawer.styles';
import { IDrawerProps } from './Drawer.types';

const Drawer = ({
  ariaLabel = 'Close',
  children,
  title,
  open = false,
  handleClose,
}: IDrawerProps): JSX.Element => {
  return (
    <StyledWrapper open={open}>
      {title && <StyledTitle>{title}</StyledTitle>}
      <StyledCloseButton aria-label={ariaLabel} onClick={handleClose}>
        <Close />
      </StyledCloseButton>
      <StyledContent>{children}</StyledContent>
    </StyledWrapper>
  );
};

export default Drawer;
